import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';

import { updatePatientPcmStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

export const useUpdatePatientPcmStatus = () => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutate, isLoading } = useMutation({
    mutationFn: updatePatientPcmStatusFn,
    onSuccess(data, { patientGuid, pcmStatus }) {
      updateCache(patientGuid, { pcmStatus });
      showResult();
    },
  });

  return { updatePcmStatus: mutate, pcmStatusLoading: isLoading };
};
